export default "__VITE_ASSET__SO8WH9O3__"